import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { toast } from '../utils/swal';
import './Login.css';
import './Register.css';

// Pending checkout — App.js ile aynı key
const SS_KEY = 'gg_pending_checkout';
const loadPendingCheckout = () => {
  try {
    const raw = sessionStorage.getItem(SS_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (Date.now() - data.savedAt > 10 * 60 * 1000) {
      sessionStorage.removeItem(SS_KEY);
      return null;
    }
    return data;
  } catch { return null; }
};

const Register = ({ onRegisterSuccess, onGoToLogin }) => {
  const { register, loading } = useAuth();
  const [form, setForm] = useState({
    fullName: '', email: '', phone: '', password: '', passwordConfirm: ''
  });
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.fullName || !form.email || !form.password) {
      toast.warning('Ad, email ve şifre zorunludur.');
      return;
    }
    if (form.password.length < 8) {
      toast.warning('Şifre en az 8 karakter olmalıdır.');
      return;
    }
    if (form.password !== form.passwordConfirm) {
      toast.warning('Şifreler eşleşmiyor.');
      return;
    }
    try {
      const user = await register({
        fullName: form.fullName,
        email:    form.email,
        phone:    form.phone,
        password: form.password
      });
      toast.success('Hesabınız oluşturuldu!');

      // Pending checkout varsa bilgileri user'a aktar
      const pending = loadPendingCheckout();
      onRegisterSuccess(user, pending);
    } catch (err) {
      toast.error(err.message || 'Kayıt başarısız.');
    }
  };

  const set = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  return (
    <div className="login-page">
      <div className="login-card register-card">
        <div className="login-logo">
          <div className="login-logo-icon">🎭</div>
          <h1 className="login-logo-text">Gişe Görevlisi</h1>
          <p className="login-logo-sub">Bilet Rezervasyon Sistemi</p>
        </div>

        <form className="login-form" onSubmit={handleSubmit}>
          <h2 className="login-title">Kayıt Ol</h2>

          <div className="login-field">
            <label>Ad Soyad</label>
            <input type="text" placeholder="Ad Soyad" value={form.fullName} onChange={set('fullName')} autoFocus />
          </div>
          <div className="login-field">
            <label>Email</label>
            <input type="email" placeholder="ornek@email.com" value={form.email} onChange={set('email')} />
          </div>
          <div className="login-field">
            <label>Telefon <span className="optional">(isteğe bağlı)</span></label>
            <input type="tel" placeholder="05xx xxx xx xx" value={form.phone} onChange={set('phone')} />
          </div>
          <div className="login-field">
            <label>Şifre</label>
            <div className="login-pass-wrap">
              <input
                type={showPass ? 'text' : 'password'}
                placeholder="En az 8 karakter"
                value={form.password}
                onChange={set('password')}
              />
              <button type="button" className="login-pass-toggle" onClick={() => setShowPass(!showPass)}>
                <i className={`fa-solid ${showPass ? 'fa-eye-slash' : 'fa-eye'}`} />
              </button>
            </div>
          </div>
          <div className="login-field">
            <label>Şifre Tekrar</label>
            <input
              type={showPass ? 'text' : 'password'}
              placeholder="Şifrenizi tekrar girin"
              value={form.passwordConfirm}
              onChange={set('passwordConfirm')}
            />
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Kayıt yapılıyor...' : 'Kayıt Ol'}
          </button>
        </form>

        <div className="login-footer">
          <span>Zaten hesabınız var mı?</span>
          <button className="login-register-link" onClick={onGoToLogin}>Giriş Yap</button>
        </div>
      </div>
    </div>
  );
};

export default Register;